import { useEffect, useRef, useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { DiagnosticAlert, DiagnosticLayout, QuestionTitle, diagnosticPrimary } from '@/components/diagnostic/DiagnosticParts';
import { Skeleton, SkeletonGroup } from '@/components/ui/Skeleton';
import { toAnswers } from '@/lib/diagnostic-steps';
import { clearDraft, finishLeadOAuth, loadDraft, loadPendingProvider, savePendingProvider, saveToken } from '@/lib/lead-diagnostic';

/** Google / Microsoft send the prospect back here; the code and state are single use. */
export const DiagnosticReturnPage = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const started = useRef(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (started.current) return;
    started.current = true;
    const code = searchParams.get('code');
    const state = searchParams.get('state');
    const provider = loadPendingProvider();
    const draft = loadDraft();
    const answers = draft ? toAnswers(draft) : null;
    if (searchParams.get('error') || !code || !state || !provider || !answers) {
      setError('La connexion n’a pas abouti. Recommencez.');
      return;
    }
    void finishLeadOAuth(provider, code, state, answers).then((result) => {
      savePendingProvider(null);
      if (!result.ok) { setError(result.message); return; }
      saveToken(result.token);
      clearDraft();
      navigate('/diagnostic', { replace: true });
    });
  }, [navigate, searchParams]);

  return (
    <DiagnosticLayout progress={null}>
      {error ? (
        <>
          <QuestionTitle>Connexion interrompue</QuestionTitle>
          <DiagnosticAlert>{error}</DiagnosticAlert>
          <Link to="/diagnostic" className={`${diagnosticPrimary} self-start`}>Revenir au diagnostic</Link>
        </>
      ) : (
        <SkeletonGroup label="Connexion" className="flex flex-col gap-6">
          <Skeleton className="h-10 w-3/4" />
          <Skeleton className="h-16 w-full" />
        </SkeletonGroup>
      )}
    </DiagnosticLayout>
  );
};
